import { HttpError } from "../errors/HttpError";

const BASE_URL =
  "https://2e9086zidh.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage";

export class Http {
  constructor(
    private readonly onError: (response: Response, body: any) => void
  ) {}
  public async get<Response extends any>(path: string): Promise<Response> {
    const response = await fetch(BASE_URL + path);

    return this.handleResponse(response);
  }

  public async post<Request extends any, Response extends any>(
    path: string,
    body: Request
  ): Promise<Response> {
    const response = await fetch(BASE_URL + path, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return await this.handleResponse(response);
  }

  public async put<Request extends any, Response extends any>(
    path: string,
    body: Request
  ): Promise<Response> {
    const response = await fetch(BASE_URL + path, {
      method: "PUT",
      body: JSON.stringify(body),
    });

    return await this.handleResponse(response);
  }

  private async handleResponse(response: Response): Promise<any> {
    let responseJson: any;
    try {
      responseJson = await response.json();
    } catch (error) {
      responseJson = null;
    }

    if (response.status > 399) {
      this.onError(response, responseJson);

      const errorMessage = responseJson?.message || "HTTP Error";
      console.error(responseJson);
      throw new HttpError(errorMessage, response, responseJson);
    }

    return responseJson;
  }
}
